import dotProp from "dot-prop";

import { DFormGroup } from "../entities/form-group";

export const isGroup = (config: DFormGroup | unknown): config is DFormGroup => {
	return (config as DFormGroup).children !== undefined;
};

export const interpolateValue = (value: string, input: any) => {
	const regexp = /\{\{(.*?)\}\}/g;

	let match = regexp.exec(value);

	let result = value;

	while (match) {
		const key = match[1].trim();
		const replacement = dotProp.get(input, key);

		if (typeof replacement !== "string" && result === match[0]) {
			return replacement;
		}

		result = result.replace(match[0], replacement as string);

		match = regexp.exec(value);
	}

	return result;
};

export const interpolate = (control: DFormGroup | unknown, input: any) => {
	if (isGroup(control)) {
		for (const c of control.children) {
			interpolate(c, input);
		}
	} else {
		for (const key of Object.keys(control)) {
			if (key === "__proto__" || key === "constructor" || key === "prototype") {
				continue;
			}

			const value = control[key];

			if (typeof value === "string" && value.includes("{{")) {
				control[key] = interpolateValue(value, input);
			} else if (Array.isArray(value)) {
				control[key] = value.map((x) => interpolate(x, input));
			} else if (value && typeof value === "object") {
				control[key] = interpolate(value, input);
			}
		}
	}

	return control;
};

export const recover = (structure: any, data: any) => {
	const regexp = /\{\{(.*?)\}\}/g;

	if (data === null) {
		return {};
	}

	if (typeof structure === "string" && structure.includes("{{")) {
		const match = new RegExp(regexp).exec(structure);

		if (match) {
			const key = match[1].trim();

			if (key === "__proto__" || key === "constructor" || key === "prototype") {
				return {};
			}

			return {
				[key]: data,
			};
		}
	} else {
		const result = {};

		for (const key of Object.keys(structure)) {
			const value = structure[key];

			const match = new RegExp(regexp).exec(value);

			if (!match) {
				continue;
			}

			const resultKey = match[1].trim();

			if (resultKey === "__proto__" || resultKey === "constructor" || resultKey === "prototype") {
				continue;
			}

			result[resultKey] = data[key];
		}

		return result;
	}

	return data;
};
